// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_REJ_BURN, SUC_REJ_BURN } from '../../../../utils/strings';

export const useRejectBurnRequest3Step = () => {
  const { submit } = useExerciseSubmission(
    RegistrarService.RegistrarService_RejectBurnRequest,
    SUC_REJ_BURN,
    ERR_REJ_BURN,
  );
  return submit;
};
